<template>
    <div class="selected-card" role="region" :aria-label="$ml.get('selectedCardAriaLabel')">
        <CardBrand :brand="cardInfos.brand.toLowerCase()" />
        <div class="selected-card__info">
            <span class="selected-card__brand">{{ cardInfos.brand }} {{ cardInfos.type }}</span>
            <span class="selected-card__digits">{{ cardInfos.lastDigits }}</span>
        </div>

        <EllipsisMenu
            v-if="!hideActions"
            class="selected-card__ellipsis-menu"
        >
            <button
                @click="handleEdit"
                type="button"
                role="menuitem"
                ref="firstOption"
            >
                {{ $ml.get('updateCardEllipsisMenu') }}
            </button>

            <button
                class="remove"
                @click="handleRemove"
                type="button"
                role="menuitem"
            >
                {{ $ml.get('deleteCardEllipsisMenu') }}
            </button>
        </EllipsisMenu>

        <RemoveCardModal
            v-if="showModal && !hideActions"
            :card="cardInfos"
            @close="handleClose"
        />
    </div>
</template>

<script>
	import { mapGetters } from 'vuex';

	import RemoveCardModal from './RemoveCardModal';
	import CardBrand from '@/components/CardBrand';
	import EllipsisMenu from '@/components/template/EllipsisMenu';
	
	export default {
		components: {
			RemoveCardModal,
			CardBrand,
			EllipsisMenu
		},

		data() {
			return {
				showModal: false
			};
		},

		props: {
			hideActions: {
				type: Boolean,
				default: false
			}
		},

		computed: {
			...mapGetters({
                selectedCard: 'dataOnFile/getSelectedCard',
            }),
			cardInfos() {
				const card = this.selectedCard;
				if (card) {
					return {
						brand: card.brand ? card.brand.charAt(0).toUpperCase() + card.brand.slice(1).toLowerCase() : '',
						type: card.type ? this.$ml.get(card.type.toLowerCase()) : '',
						lastDigits: card.maskedNumber ? `•••• ${card.maskedNumber.slice(-4)}` : '',
						id: card.id,
					};
				} else {
					return {
						brand: '',
						type: '',
						lastDigits: ''
					};
				}
			}
		},

		methods: {
			openRemoveCardModal() {
				this.showModal = true;
			},

			handleClose() {
				this.showModal = false;
			},

			handleEdit() {
				this.$store.dispatch('pipelineV2/pushTo', 'DataOnFileEditCard');
			},
			
			handleRemove() {
				this.openRemoveCardModal();
			},
		},
	};
</script>

<style scoped lang="scss">
	.selected-card {
		position: relative;
		display: flex;
		align-items: center;
		gap: 12px;
		border: 1.5px solid #B8C1CC;
		border-radius: 12px;
		padding: 16px;

		&__info {
			display: flex;
			flex-direction: column;
		}

		&__brand {
			font-size: 1rem;
			font-weight: 500;
			color: #2F363E;
		}

		&__text--digits {
			font-size: .875rem;
			font-weight: 500;
			color: #5C6A7B;
		}

		&__ellipsis-menu {
			position: absolute;
			right: 16px;
			top: 50%;
			transform: translateY(-50%);
		}

		&:focus-within {
			outline: 2px solid #1976d2;
			outline-offset: 2px;
		}
	}
</style>
